import './index.css';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { applyMiddleware, createStore } from 'redux';

import App from './App';
import activities from './middlewares/activities';
import boards from './middlewares/boards';
import groups from './middlewares/groups';
import members from './middlewares/members';
import memos from './middlewares/memos';
import notes from './middlewares/notes';
import wikis from './middlewares/wikis';
import reducers from './reducers';

// import registerServiceWorker from './registerServiceWorker';

const middlewares = [groups, members, memos, notes, wikis, boards, activities];
const store = createStore(reducers, applyMiddleware(...middlewares));

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root') as HTMLElement
);

// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx